import { getCoord } from './scene';
/**
 * box offset to four edge
 * @param pos
 */
export const computeBoundingbox = (pos) => {
    if (!pos) {
        return {
            offsetLeft: 0,
            offsetRight: 0,
            offsetTop: 0,
            offsetBottom: 0,
        };
    }
    const [coordx, coordy] = getCoord();
    const { x, y } = pos;
    return {
        offsetLeft: x > 0 ? coordx + x : coordx - Math.abs(x),
        offsetRight: x > 0 ? coordx - x : coordx + Math.abs(x),
        offsetTop: y > 0 ? coordy - y : coordy + Math.abs(y),
        offsetBottom: y > 0 ? coordy + y : coordy - Math.abs(y),
    };
};
